module.exports = __webpack_public_path__ + "img/demo_1.350f6706.png";